export var LogoVariant = /*#__PURE__*/function (LogoVariant) {
  LogoVariant["MLSpace"] = "MLSpace";
  LogoVariant["Cloud"] = "Cloud";
  LogoVariant["None"] = "None";
  return LogoVariant;
}({});
export var ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["FrontendError"] = "FrontendError";
  ErrorType["PageUnavailable"] = "PageUnavailable";
  ErrorType["PageNotFound"] = "PageNotFound";
  ErrorType["Offline"] = "Offline";
  ErrorType["Redirect"] = "Redirect";
  return ErrorType;
}({});
export var COLORS = {
  svgExclamationMark: '--svgExclamationMark',
  svgStroke: '--svgStroke',
  svgBackground: '--svgBackground'
};